import { differenceInSeconds } from 'date-fns';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useInterval } from 'usehooks-ts';

import CircularTimer from './components/CircularTimer';
import { formatTime, getTotalTime } from './utils/formatters';

import { usePomodoroStore } from '@/apps/Pomodoro/stores/usePomodoroStore';
import LoadingSpinner from '@/common/components/LoadingSpinner';
import { useAlertStore } from '@/common/stores/useAlertStore';
import { useAuthStore } from '@/common/stores/useAuthStore';

export default function Pomodoro() {
  const { t } = useTranslation();
  const {
    mode,
    currentPhase,
    nextPhaseTime,
    switchPhase,
    isLoading,
    loadUserPreferences
  } = usePomodoroStore();
  const showAlert = useAlertStore((state) => state.showAlert);
  const [timeLeft, setTimeLeft] = useState<number>(0);
  const { user } = useAuthStore();

  useEffect(() => {
    if (user) {
      loadUserPreferences(user.id);
    }
  }, [JSON.stringify(user)]);

  // Update time left
  useInterval(() => {
    if (!nextPhaseTime) return;

    const secondsLeft = differenceInSeconds(nextPhaseTime, new Date());

    if (secondsLeft <= 0) {
      const isFocus = currentPhase === 'focus';
      showAlert({
        type: isFocus ? 'success' : 'danger',
        message: isFocus ? t('pomodoro.timeForBreak') : t('pomodoro.timeForFocus'),
        duration: 5,
      });
      switchPhase();
    } else {
      setTimeLeft(secondsLeft);
    }
  }, 1000);

  useEffect(() => {
    if (nextPhaseTime) {
      setTimeLeft(differenceInSeconds(nextPhaseTime, new Date()));
    }
  }, [nextPhaseTime]);

  return (
    <div className="h-full overflow-auto flex flex-col items-center justify-center">
      {isLoading ? (
        <div className="flex justify-center items-center h-full">
          <LoadingSpinner />
        </div>
      ) : (
        <div className="flex flex-col items-center space-y-8 w-full h-full">
          <CircularTimer
            formattedTime={formatTime(timeLeft)}
            phase={currentPhase}
            timeLeft={timeLeft}
            totalTime={getTotalTime(mode, currentPhase)}
          />
        </div>
      )}
    </div>
  );
}
